/* スクロールに合わせてふわっと下から上に表示
---------------------------------------------- */
export const FADE_UP = {
  init: function () {
    // インターセクションオブザーバーのオプション
    const options = {
      root: null,
      rootMargin: '0px 0px',
      threshold: 0,
    }

    // フェードアップ用のオブザーバー
    const fadeUpObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-fade-up')
        }
      })
    }, options)

    // フェードイン用のオブザーバー
    const fadeInObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-fade-in')
          }
        })
      },
      {
        ...options,
        rootMargin: '-50px 0px 100px 0px',
      },
    )

    // 要素の監視を開始
    document.querySelectorAll('.fade-up-el').forEach(el => {
      fadeUpObserver.observe(el)
    })

    document.querySelectorAll('.fade-in-el').forEach(el => {
      fadeInObserver.observe(el)
    })
  },
}
